import root from './_root';

/** Built-in value references. */
var Reflect = root.Reflect;

export default Reflect;
